module.exports = __webpack_public_path__ + "static/img/case1Left1.de19a27d.png";